import api from '../api';
let apiUrl = 'aboutus';

const state = {
    data: {},
    meta: {}
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                commit('set', response.data);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    all: (state) => {
        return state.data;
    },
    getById: (state) => (id) => {
        return state.data.find((item) => item.id === id);
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
